import toast from 'react-hot-toast';

// Custom toast configurations using CYGA colors
export const showToast = {
  success: (message) => {
    toast.success(message, {
      duration: 3000,
      position: 'top-right',
      style: {
        background: '#1a1a1a',
        color: '#ffffff',
        border: '1px solid #22c55e',
        borderRadius: '8px',
        padding: '12px 16px',
      },
      iconTheme: {
        primary: '#22c55e',
        secondary: '#1a1a1a',
      },
    });
  },
  
  error: (message) => {
    toast.error(message, {
      duration: 4000,
      position: 'top-right',
      style: {
        background: '#1a1a1a',
        color: '#ffffff',
        border: '1px solid #ef4444',
        borderRadius: '8px',
        padding: '12px 16px',
      },
      iconTheme: {
        primary: '#ef4444',
        secondary: '#1a1a1a',
      },
    });
  },
  
  loading: (message) => {
    return toast.loading(message, {
      position: 'top-right',
      style: {
        background: '#1a1a1a',
        color: '#ffffff',
        border: '1px solid #ff6b35',
        borderRadius: '8px',
        padding: '12px 16px',
      },
    });
  },
  
  promise: (promise, messages) => {
    return toast.promise(
      promise,
      {
        loading: messages.loading,
        success: messages.success,
        error: messages.error,
      },
      {
        style: {
          background: '#1a1a1a',
          color: '#ffffff',
          border: '1px solid #ff6b35',
          borderRadius: '8px',
          padding: '12px 16px',
        },
        success: {
          iconTheme: {
            primary: '#22c55e',
            secondary: '#1a1a1a',
          },
        },
        error: {
          iconTheme: {
            primary: '#ef4444',
            secondary: '#1a1a1a',
          },
        },
      }
    );
  },
  
  warning: (message) => {
    toast(message, {
      duration: 3500,
      position: 'top-right',
      icon: '⚠️',
      style: {
        background: '#1a1a1a',
        color: '#ffffff',
        border: '1px solid #fbbf24',
        borderRadius: '8px',
        padding: '12px 16px',
      },
    });
  },
  
  info: (message) => {
    toast(message, {
      duration: 3000,
      position: 'top-right',
      icon: 'ℹ️',
      style: {
        background: '#1a1a1a',
        color: '#ffffff',
        border: '1px solid #3b82f6',
        borderRadius: '8px',
        padding: '12px 16px',
      },
    });
  },
};

export default showToast;
